// FollowUpToggle.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  getMessageTasks,
  triggerMessageTask,
} from "../../../../services/flow.service";
import { Loading } from "../../../../components/ToggleButtons/Loading";
import { Toggle } from "../../../../components/ToggleButtons/Toggle";

type FollowUpToggleProps = {
  flowId: string;
  data: any; 
};
export const OnHoldToggle = ({ flowId, data }: FollowUpToggleProps) => {
  const onHoldToggle = data?.queues.onHold ?? false;
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(onHoldToggle);
  const [successOperation, setSuccessOperation] = useState(onHoldToggle);
  const [toggleState, setToggleState] = useState(checked && successOperation);


  const handleToggle = async () => {
    const newValue = !checked;
    const oldSuccessOperation = successOperation;
    setChecked(newValue);
    setSuccessOperation(false);
    setIsLoading(true);

    try {
      // Fetch the message tasks for the flow
      const messageTasks = await getMessageTasks(flowId);

      const followUpTask = messageTasks.find((task: { taskType: string }) => task.taskType === "follow-up-toggle") ?? undefined;

      if (!followUpTask) {
        console.error("Follow-up task not found");
        setChecked(!newValue); // Revert on error
        setSuccessOperation(oldSuccessOperation); // Restore previous success state
        return;
      }

      await triggerMessageTask(followUpTask.taskId, {
        onHoldEnabled: newValue,
      });

      // Update the local state to reflect the successful operation
      setSuccessOperation(true);
      setToggleState(newValue && true);
    } catch (error) {
      console.error("Error updating follow-up state:", error);
      setChecked(!newValue); // Revert on error
      setSuccessOperation(oldSuccessOperation); // Restore previous success state
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  
  return (
    <Toggle toggleState={toggleState} handleToggle={handleToggle} />
  );
};